import { render } from "./ListeComposition.vue?vue&type=template&id=84fc5c20&scoped=true&ts=true"
import script from "./ListeComposition.vue?vue&type=script&lang=ts"
export * from "./ListeComposition.vue?vue&type=script&lang=ts"

import "./ListeComposition.vue?vue&type=style&index=0&id=84fc5c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fc5c20"]])

export default __exports__